<ng-template #trainrunAndSectionEditorTabsViewTemplate>
  <div
    class="MainTrainrunTabViewDialog"
    sbbDialog
    (mouseup)="onMouseUp($event)"
    (mousemove)="onMouseMove($event)"
    (mousedown)="onMouseDown($event)"
  >
    <sbb-icon
      class="closeDialog"
      svgIcon="cross-small"
      aria-label="Clode Dialogr"
      aria-hidden="false"
      (click)="closeDialog()"
    ></sbb-icon>
    <div class="TrainrunTabGrupe">
      <sbb-tab-group [selectedIndex]="data.type">
        <sbb-tab
          label="{{ selectedTrainrun.getCategoryShortName() }}{{
            selectedTrainrun.getTitle()
          }}"
          id="trainrun-tab"
        >
          <sbb-trainrun-tab
            [trainrunDialogParameter]="trainrunDialogParameter"
            (trainrunDeleted)="closeDialog()"
          ></sbb-trainrun-tab>
        </sbb-tab>
        <sbb-tab
          label="{{ selectedTrainrunSectionName }}"
          id="trainrun-section-tab"
        >
          <sbb-trainrunsection-tab
            [trainrunDialogParameter]="data"
          ></sbb-trainrunsection-tab>
        </sbb-tab>
        <sbb-tab [label]="'app.view.dialogs.trainrun-and-section-dialog.filterableLabels' | translate"
                 id="trainrun-filterable-labels-tab">
          <sbb-trainrun-filter-tab
            (trainrunDeleted)="closeDialog()"
          ></sbb-trainrun-filter-tab>
        </sbb-tab>
      </sbb-tab-group>
    </div>
  </div>
</ng-template>
